import { css } from '@emotion/core';
import styleService from '@nykaa/deals-utils/styles';
import styled from '../../theme';
const { getPaddingStyles, getMarginStyles, getFontStyles, getBKGStyles, getBorderStyles, } = styleService.utils;
export const CardWrapper = styled.div `
  position: relative;
  display: inline-block;
  width: ${({ width }) => `${width}px`};
  vertical-align: top;
  margin-right: ${({ interItem, isDesktop }) => (isDesktop ? '1.5rem' : interItem.web)};
  ${({ padding }) => getPaddingStyles(padding)};
  a {
    text-decoration: none;
  }
  .width-limiter {
    max-width: 100%;
    display: block !important;
  }
  :first-of-type {
    margin-left: ${({ isDesktop }) => (isDesktop ? '3rem' : '1.25rem')};
  }
  :last-of-type {
    margin-right: ${({ isDesktop }) => (isDesktop ? '3rem' : '1.25rem')};
  }
  @media only screen  and (min-width : 1600px) {
    margin-right: ${({ interItem }) => (interItem.web)};
    :first-of-type {
      margin-left: auto;
    }
    :last-of-type {
      margin-right: auto;
    }
  }
`;
export const basicButton = css `
  display: inline-block;
  background: none;
  border: none;
`;
export const ButtonGroup = styled.div `
  width: 100%;
  position: relative;
  bottom: 0px;
  ${({ background }) => getBKGStyles(background)};
  ${({ border }) => getBorderStyles(border)};
  border-radius: ${({ cornerRadius }) => cornerRadius.web};
  height: ${({ isDesktop }) => (isDesktop ? '2.5rem' : '2rem')};
  display: flex;
  ${({ margin }) => getMarginStyles(margin)};
  .add_to_cart {
    ${basicButton};
    ${({ padding }) => getPaddingStyles(padding)};
    ${({ text }) => getFontStyles(text)};
    width: calc(100% - 2rem);
    flex-basis: 100%;
    text-overflow: ellipsis;
    max-width: -webkit-fill-available;
    clear: both;
    display: inline-block;
    overflow: hidden;
    white-space: nowrap;
    ${({ border }) => getBorderStyles(border)};
    border-top: none;
    border-right: none;
    border-bottom: none;
    .disabled {
      color: gray;
    }
  }
  .wishlist {
    ${basicButton}
    ${({ padding }) => getPaddingStyles(padding)};
    ${({ text }) => getFontStyles(text)};
    width: 2.4405rem;
    mask-image: ${({ isProductInWishList }) => (isProductInWishList ? 'url(https://www.nykaa.com/media/wysiwyg/2022/core/heart-filled.svg)' : 'url(https://www.nykaa.com/media/wysiwyg/2022/core/heart-plus.svg)')}; 
    mask-repeat: no-repeat;
    mask-position: center;
    mask-size:  ${({ isDesktop }) => (isDesktop ? '24px 24px' : '16px 16px')};
    background-color: ${({ text }) => text.color};
  }
`;
export const ProductUnit = styled.div `
  ${({ margin }) => getMarginStyles(margin)};
  ${({ padding }) => getPaddingStyles(padding)};
  ${({ text }) => getFontStyles(text)};
  min-height: 14px;
  text-overflow: ellipsis;
  max-width: -webkit-fill-available;
  clear: both;
  display: list-item;
  overflow: hidden;
  white-space: nowrap;
`;
export const Message = styled.div `
  color: green;
  ${({ margin }) => getMarginStyles(margin)};
  ${({ padding }) => getPaddingStyles(padding)};
  ${({ text }) => getFontStyles(text)};
  text-overflow: ellipsis;
  max-width: -webkit-fill-available;
  clear: both;
  display: inline-block;
  overflow: hidden;
  min-height: 18.5px;
  white-space: nowrap;
`;
export const ProductPrice = styled.div `
  ${({ margin }) => getMarginStyles(margin)};
  ${({ padding }) => getPaddingStyles(padding)};
  overflow: hidden;
  white-space: nowrap;
  display: block;
  text-overflow: ellipsis;
  .sale-price {
    ${({ salePriceText }) => getFontStyles(salePriceText)};
    display: inline;
  }
  .mrp-price {
    text-decoration: line-through;
    ${({ mrpPriceText }) => getFontStyles(mrpPriceText)};
    padding-top: 1px;
    margin: 0rem 0.25rem;
    display: inline;
  }
  .discounted-price {
    ${({ discountText }) => getFontStyles(discountText)};
    padding: 2px 0px 1px;
    display: inline;
  }
`;
export const Sticker = styled.div `
  width: 33px;
  height: 33px;
  background-size: contain;
  background-image: url(${({ url }) => url});\
  background-repeat: no-repeat;
  background-position: center;
  ${({ margin }) => getMarginStyles(margin)};
`;
export const Highlights = styled.ul `
${({ background }) => getBKGStyles(background)};
${({ margin }) => getMarginStyles(margin)};
${({ padding }) => getPaddingStyles(padding)};
${({ text }) => getFontStyles(text)};
list-style-type: none;
overflow: hidden;
text-overflow: ellipsis;
white-space: nowrap;
flex: 3;
border-bottom-right-radius: 3px;
border-bottom-left-radius: 3px;
li {
  display: inline;
  white-space: nowrap;
}
li:after { 
  content:" ";
  letter-spacing:1em;
  background:center center no-repeat url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAUAAAAFCAYAAACNbyblAAAABGdBTUEAALGPC/xhBQAAAAlwSFlzAAAOwAAADsABataJCQAAABl0RVh0U29mdHdhcmUAcGFpbnQubmV0IDQuMC4xMkMEa+wAAAAnSURBVBhXY/Dz89MA4sNA/B9Ka4AEYQIwfBgkiCwAxjhVopnppwEApxQqhnyQ+VkAAAAASUVORK5CYII=);
}
`;
export const ProductContent = styled.div `
flex-grow: 1;
border: none;
background: 0 0;
margin: 0;
-webkit-box-shadow: none;
box-shadow: none;
font-size: 1em;
border-radius: 0;
max-width: 100%;
.header {
  display: inline-block;
  ${({ padding }) => getPaddingStyles(padding)};
  min-height: 36px;
  ${({ brandStyle }) => getFontStyles(brandStyle)};
  vertical-align: top;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  overflow: hidden;
  white-space: normal;
  text-overflow: ellipsis;
  -webkit-line-clamp: ${({ productStyle }) => productStyle.maxLines.web};
  line-height: ${({ brandStyle }) => brandStyle.font.web.lineHeight} !important;

  span { 
    margin-right: 4px;
  }
  .product-name {
  display: inline;
  ${({ productStyle }) => getFontStyles(productStyle)};
  overflow: hidden;
  text-overflow: ellipsis;
  vertical-align: top;
  -webkit-line-clamp: ${({ brandStyle }) => brandStyle.maxLines.web};
  line-height: ${({ productStyle }) => productStyle.font.web.lineHeight} !important;
}
`;
export const ProductCardWrapper = styled.div `
    max-width: 100%;
    position: relative;
    display: flex;
    flex-direction: column;
    min-height: 0;
    border: none;
    border-radius: 0.58571429rem;
    z-index: '';
    cursor: ${({ isDesktop }) => (isDesktop && 'pointer')}; 
   }
   .product-image{
    display: flex;
    flex-direction: column;
    width: 100%;
    height: ${({ width }) => `${width}px`};;
    border-radius: 4px;
    position: relative;
    aspect-ratio: 3/4;
    background-color: #fff;
    border: 1px solid rgba(0, 19, 37, 0.08);
    .product-head{
     flex: 1;
     visibility : ${({ tagText }) => (tagText ? 'visible' : 'hidden')};
    }
    img {
      width: 100%;
    }
   }
   }
`;
export const ProductTag = styled.span `
  ${({ margin }) => getMarginStyles(margin)};
  ${({ padding }) => getPaddingStyles(padding)};
  border-radius: ${({ cornerRadius }) => cornerRadius.web};
  ${({ text }) => getFontStyles(text)};
  ${({ background }) => getBKGStyles(background)};
  text-overflow: ellipsis;
  max-width: -webkit-fill-available;
  clear: both;
  display: inline-block;
  overflow: hidden;
  position: absolute;
  top:0;
  left: 0;
  white-space: nowrap;
`;
export const ImageContainer = styled.div `
.container {
  display: flex;
  align-items: center;
  flex: 2;
  background-image: url(${({ imageUrl }) => imageUrl});
  height: ${({ isHighlight, width }) => (isHighlight ? `calc(${width}px - 22px)` : `${width}px`)};
  background-size: contain;
  background-position: center;
  background-repeat: no-repeat;
  border-bottom-left-radius: 3px;
  border-bottom-right-radius: 3px;
  position: relative;
}
.sticker-container {
  flex: 2;
  width: 100%;
  display: flex;
  justify-content: flex-end;
  align-self: flex-end;
}
 .ratings-container {
  flex: 1;  
  align-self: flex-end;  
}
`;
export const Ratings = styled.div `
  ${({ margin }) => getMarginStyles(margin)};
  ${({ padding }) => getPaddingStyles(padding)};
  ${({ background }) => getBKGStyles(background)};
  border-radius:   ${({ cornerRadius }) => cornerRadius.web};
  .actual-rating {
    ${({ actualRatingText }) => getFontStyles(actualRatingText)};
  }
  .rating-count {
    ${({ maxRatingtext }) => getFontStyles(maxRatingtext)};
  }
`;
